import { AppNavigationProvider } from '@euler/app/components/AppNavigationProvider';
import { ReworkRecordContext } from '@euler/app/flows/task/pages/delivery-check/rework-record/Provider';
import { useNavBack } from '@euler/app/flows/task/pages/inspection/site-inspection/BackButton';
import { ModalWrapper } from '@euler/components/ModalWrapper';
import { transparentModalOptions } from '@euler/functions/navigationOptionsBuilder';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { ReworkRecordStaged } from '@euler/model/task-detail/ReworkRecord';
import { useCallback } from 'react';
import { ReworkRecordFlowNavigator } from './ReworkRecordFlowNavigator';

export const ReworkRecordFlow = wrapNavigatorScreen(
  (props: {
    recordInfo: ReworkRecordStaged;
    onDone?: (record: ReworkRecordStaged) => void;
  }) => {
    const navBack = useNavBack();

    const onDone = useCallback(
      (record: ReworkRecordStaged) => {
        navBack();
        props.onDone?.(record);
      },
      [navBack, props],
    );

    return (
      <AppNavigationProvider>
        <ModalWrapper dismissible={false} height={600}>
          <ReworkRecordContext.Provider value={{ footerSlotName: undefined }}>
            <ReworkRecordFlowNavigator
              recordInfo={props.recordInfo}
              onCancel={navBack}
              onDone={onDone}
            />
          </ReworkRecordContext.Provider>
        </ModalWrapper>
      </AppNavigationProvider>
    );
  },
  transparentModalOptions(),
);
